if (!customElements.get('aureme-preorder-handler')) {
  const PREORDER_STATUS_VALUE = '予約商品';
  const NORMAL_STATUS_VALUE = '通常商品';

  function syncHiddenInput(id, value, disabled = false) {
    const input = document.getElementById(id);
    if (!input) return;

    input.value = value;
    input.disabled = disabled;
  }

  /*
   * PDP の購入状態を variant 変更に合わせて hidden property と表示文言へ同期する。
   * checkout / order 履歴側が読む公開 property をここで単一化する。
   */
  customElements.define(
    'aureme-preorder-handler',
    class AuremePreorderHandler extends HTMLElement {
      variantChangeUnsubscriber = undefined;
      _preorderData = undefined;

      connectedCallback() {
        this._preorderData = this._parsePreorderData();
        this.updatePreorderState();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data?.sectionId) !== String(this.dataset.sectionId)) return;
          this.updatePreorderState();
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this._preorderData = undefined;
      }

      _parsePreorderData() {
        const script = document.getElementById(`AuremePreorderData-${this.dataset.sectionId}`);
        if (!script?.textContent) return [];

        try {
          return JSON.parse(script.textContent);
        } catch {
          return [];
        }
      }

      get preorderData() {
        return this._preorderData || [];
      }

      get submitButton() {
        return document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
      }

      get deliveryDateEl() {
        return document.getElementById(`AuremeDeliveryDate-${this.dataset.sectionId}`);
      }

      get isCartLimitReached() {
        return this.submitButton?.dataset.cartLimitReached === 'true';
      }

      get currentVariantId() {
        const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
        const input = form?.querySelector('input.product-variant-id');
        return input ? Number(input.value) : null;
      }

      updatePreorderState() {
        const variantId = this.currentVariantId;
        if (!variantId) {
          this.updateDeliveryDate(false);
          return;
        }

        const variantData = this.preorderData.find((v) => v.id === variantId);
        const isPreorder = variantData?.isPreorder === true;
        /*
         * saleStatus は通常商品でも checkout / order の公開 property として送る。
         * variant データに明示値がない場合は、現行の予約判定から通常/予約の既定値へ落とす。
         */
        const fallbackSaleStatus = isPreorder ? PREORDER_STATUS_VALUE : NORMAL_STATUS_VALUE;
        const saleStatus =
          typeof variantData?.saleStatus === 'string' && variantData.saleStatus !== ''
            ? variantData.saleStatus
            : fallbackSaleStatus;
        const deliveryDate =
          typeof variantData?.deliveryDate === 'string' ? variantData.deliveryDate : '';
        const shouldShowDeliveryDate =
          isPreorder && deliveryDate !== '' && !this.isCartLimitReached;

        this.updateButton(isPreorder);
        this.updateDeliveryDate(shouldShowDeliveryDate, deliveryDate);

        /* カートフォームの hidden input を同期 */
        const sectionId = this.dataset.sectionId;
        const preorderDeliveryDate = isPreorder ? deliveryDate : '';
        const preorderDeliveryDateDisabled = preorderDeliveryDate === '';

        syncHiddenInput(`SaleStatus-${sectionId}`, saleStatus);
        /* 空文字も未設定扱いにそろえて hidden input の送信有無を制御する */
        syncHiddenInput(
          `PreorderDeliveryDate-${sectionId}`,
          preorderDeliveryDate,
          preorderDeliveryDateDisabled,
        );
      }

      updateButton(isPreorder) {
        const button = this.submitButton;
        if (!button) return;

        button.dataset.preorder = String(isPreorder);

        /* 在庫切れや購入上限到達など disabled 状態の文言はサーバー描画を優先する */
        if (button.disabled) return;

        const span = button.querySelector('span');
        if (!span) return;

        span.textContent = isPreorder ? '予約する' : 'カートに追加';
      }

      updateDeliveryDate(shouldShowDeliveryDate, deliveryDate) {
        const el = this.deliveryDateEl;
        if (!el) return;

        if (shouldShowDeliveryDate) {
          el.hidden = false;
          const valueEl = el.querySelector('.aureme-product-detail__delivery-value');
          if (valueEl) valueEl.textContent = deliveryDate;
        } else {
          el.hidden = true;
        }
      }
    },
  );
}
